import React from 'react';

interface AiAvatarProps {
  className?: string;
}

const AiAvatar: React.FC<AiAvatarProps> = ({ className = '' }) => (
  <div className={`ai-avatar ${className}`}>
    <div className="avatar-circle">
      <svg className="neural-network" viewBox="0 0 100 100">
        <line x1="50" y1="50" x2="20" y2="20" className="connection line-1" />
        <line x1="50" y1="50" x2="80" y2="20" className="connection line-2" />
        <line x1="50" y1="50" x2="80" y2="80" className="connection line-3" />
        <line x1="50" y1="50" x2="20" y2="80" className="connection line-4" />
        <line x1="50" y1="50" x2="50" y2="10" className="connection line-5" />
        <line x1="50" y1="50" x2="90" y2="50" className="connection line-6" />
        <line x1="50" y1="50" x2="50" y2="90" className="connection line-7" />
        <line x1="50" y1="50" x2="10" y2="50" className="connection line-8" />
        <line x1="20" y1="20" x2="50" y2="10" className="connection-thin line-9" />
        <line x1="80" y1="20" x2="90" y2="50" className="connection-thin line-10" />
        <line x1="80" y1="80" x2="50" y2="90" className="connection-thin line-11" />
        <line x1="20" y1="80" x2="10" y2="50" className="connection-thin line-12" />
      </svg>
      <svg className="avatar-logo" viewBox="0 0 100 100" aria-label="WWG Logo">
        <rect width="100" height="100" rx="22" fill="#E8192C" />
        <path d="M18 22 L34 38 L18 54 L34 70 L18 86 L30 86 L46 70 L30 54 L46 38 L30 22 Z" fill="white" />
        <path d="M48 22 L64 38 L48 54 L64 70 L48 86 L60 86 L76 70 L60 54 L76 38 L60 22 Z" fill="white" />
      </svg>
      <div className="neuron neuron-1"></div>
      <div className="neuron neuron-2"></div>
      <div className="neuron neuron-3"></div>
      <div className="neuron neuron-4"></div>
      <div className="neuron neuron-5"></div>
      <div className="neuron neuron-6"></div>
      <div className="neuron neuron-7"></div>
      <div className="neuron neuron-8"></div>
      <div className="avatar-ring ring-1"></div>
      <div className="avatar-ring ring-2"></div>
      <div className="avatar-ring ring-3"></div>
      <div className="avatar-particles">
        <span className="particle p-1"></span>
        <span className="particle p-2"></span>
        <span className="particle p-3"></span>
        <span className="particle p-4"></span>
        <span className="particle p-5"></span>
        <span className="particle p-6"></span>
        <span className="particle p-7"></span>
        <span className="particle p-8"></span>
      </div>
    </div>
  </div>
);

export default AiAvatar;
